import {ROUTES} from '../../../../_gori/constants'

export const OrderStatus = {
  OPEN: 'open',
  SHIPPED: 'shipped',
  AWAITING_PAYMENT: 'awaiting_payment',
  ON_HOLD: 'on_hold',
  CANCELLED: 'cancelled',
  ERROR: 'error',
}

export const OrderChildModalName = {
  CREATE_LABEL: 'createLabel',
  EDIT_ORDER: 'editOrder',
} as const

export type OrderChildModalNameType = typeof OrderChildModalName[keyof typeof OrderChildModalName]

export const OrdersConfig = {
  PAGE_SIZE_ADDRESS: 200,
  CREATE_ALL_LABEL: 10,
  GET_CHEAPEST_SERVICE: 100,
  GET_ESTIMATED_SERVICE: 100,
  SHIPPING: {
    COMPANY: {label: 'COMPANY', value: 'company', required: true},
    FIRST_NAME: {label: 'FIRST_NAME', value: 'first_name', required: true},
    LAST_NAME: {label: 'LAST_NAME', value: 'last_name'},
    EMAIL: {label: 'EMAIL', value: 'email'},
    PHONE: {label: 'PHONE', value: 'phone'},
    ADDRESS: {label: 'ADDRESS', value: 'street1', required: true},
    ADDRESS_2: {label: 'ADDRESS_2', value: 'street2'},
    CITY: {label: 'CITY', value: 'city', required: true},
    STATE: {label: 'STATE', value: 'state', required: true},
    COUNTRY: {label: 'COUNTRY', value: 'country', required: true},
    ZIP_CODE: {label: 'POSTAL_CODE', value: 'zip', required: true},
    RESIDENTIAL: {label: 'RESIDENTIAL', value: 'is_residential'},
    VERIFIED: {label: 'VERIFIED', value: 'is_verified'},
    SAVE_ADDRESS: {label: 'SAVE_ADDRESS', value: 'type'},
  },
  VALIDATE_ADDRESS: ['city', 'country', 'state', 'street1', 'street2', 'zip'],
  PARCEL: ['length', 'width', 'height', 'weight', 'dimension_unit', 'weight_unit', 'package_count'],
  ITEMS: {
    TITLE: {label: 'NAME', value: 'title', type: 'text'},
    SKU: {label: 'SKU', value: 'sku', type: 'text'},
    QUANTITY: {label: 'QUANTITY', value: 'quantity', type: 'number'},
    PRICE: {label: 'ITEM_VALUE', value: 'unit_price', type: 'number'},
  },
  CUSTOMS: {
    CONTENT: {label: 'CONTENT', value: 'content', type: 'text'},
    DESCRIPTION: {label: 'DESCRIPTION', value: 'description', type: 'text'},
    ITEMS: {
      DESCRIPTION: {label: 'DESCRIPTION', value: 'description', type: 'text', required: true},
      HS_TARIFF_NUMBER: {
        label: 'HS_TARIFF_NUMBER',
        value: 'hs_tariff_number',
        type: 'text',
        required: false,
      },
      COUNTRY_OF_ORIGIN: {
        label: 'COUNTRY_OF_ORIGIN',
        value: 'country',
        type: 'text',
        required: true,
      },
      QUANTITY: {label: 'QUANTITY', value: 'quantity', type: 'number', required: true},
      VALUE: {label: 'VALUE', value: 'value', type: 'number', required: true},
      WEIGHT: {label: 'WEIGHT', value: 'weight', type: 'number', required: true},
    },
  },
  US_TERRITORIES: ['AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'],
  US_MILITARIES: ['APO', 'FPO', 'DPO'],
  SERVICE_FILTER: {
    TERRITORIES: ['usps_ground_advantage', 'usps_priority', 'ups_ground'],
    MILITARIES: ['usps_ground_advantage', 'usps_priority'],
  },
  MASS_UPDATE: [
    {label: 'PRESETS', value: 'preset'},
    {label: 'SHIP_FROM', value: 'from'},
    {label: 'SHIP_TO', value: 'to'},
    {label: 'SERVICE', value: 'service'},
    {label: 'PACKAGE', value: 'package_type'},
    {label: 'WEIGHT', value: 'weight'},
    {label: 'SIZE', value: 'parcels'},
    {label: 'SHIP_BY', value: 'ship_by_date'},
  ],
}

export const INSURANCE_TYPE = {
  CARRIER: 'carrier',
  BAE_GUARD: 'bae_guard',
}

export const UNIT_VALUES = {
  WEIGHT_CARRIER: {
    oz: {max: 1120},
    lb: {max: 70},
    gm: {max: 31751},
    kg: {max: 31.5},
  },
  WEIGHT: {
    oz: {max: 10000},
    lb: {max: 625},
    gm: {max: 283495},
    kg: {max: 283.5},
  },
  DIMENSION: {
    in: {max: 100},
    cm: {max: 254},
    mm: {max: 2540},
  },
  PACKAGE_COUNT: {
    max: 199,
    limit_each_row: 199,
    limit_row: 50,
  },
}

export const OPTIONS_CONTENT_TYPE_UPS = [
  {label: 'GIFT', value: 'gift'},
  {label: 'DOCUMENTS', value: 'documents'},
  {label: 'SAMPLE', value: 'sample'},
  {label: 'OTHER', value: 'other'},
]

export const OPTIONS_CONTENT_TYPE_FEDEX = [
  {label: 'GIFT', value: 'gift'},
  {label: 'SAMPLE', value: 'sample'},
  {label: 'SOLD', value: 'sold'},
  {label: 'REPAIR_AND_RETURN', value: 'repair_and_return'},
  {label: 'PERSONAL_EFFECTS', value: 'personal_effects'},
  {label: 'NOT_SOLD', value: 'not_sold'},
]

export const CONTENT_TYPE_CATEGORY = {
  GENERAL: 'GENERAL',
  FEDEX: 'FEDEX_CATEGORIES',
} as const

export const FEDEX_PARCEL_LIMIT = 30

export const FEDEX_INTERNATIONAL_SERVICES = [
  'fedex_international_economy',
  'fedex_international_priority',
]

export const USPS_INTERNATIONAL_SERVICES = [
  'usps_first_package_international',
  'usps_first_international',
  'usps_priority_international',
  'usps_express_international',
]

export const OPTIONS_CONTENT_TYPE = [
  {label: 'MERCHANDISE', value: 'merchandise'},
  {label: 'GIFT', value: 'gift'},
  {label: 'DOCUMENTS', value: 'documents'},
  {label: 'SAMPLE', value: 'sample'},
  {label: 'RETURN', value: 'return'},
  {label: 'HUMANITARIAN', value: 'humanitarian'},
  {label: 'DANGEROUS_GOODS', value: 'dangerous_goods'},
  {label: 'OTHER', value: 'other'},
]

// Valid content types for FedEx international services
export const VALID_FEDEX_CONTENT_TYPES = OPTIONS_CONTENT_TYPE_FEDEX.map((opt) => opt.value)

// Valid content types for non-FedEx international services (General)
export const VALID_GENERAL_CONTENT_TYPES = OPTIONS_CONTENT_TYPE.map((opt) => opt.value)

// Content types that exist in both FedEx and General categories (no rate refresh needed when switching)
export const OVERLAPPING_CONTENT_TYPES = ['gift', 'sample']

export const OPTION_PACKAGE_TYPE = {
  INPUT_DIMENSION: {label: 'INPUT_DIMENSION', value: 'input_dimension'},
  CUSTOM_PACKAGE: {label: 'CUSTOM_PACKAGE', value: 'custom_package'},
  CARRIER_STANDARD_PACKAGE: {label: 'CARRIER_STANDARD_PACKAGE', value: 'carrier_standard_package'},
}

export const CARRIER_PACKAGE_TYPE = [
  {
    label: 'USPS Priority Mail Flat Rate Package',
    value: 'usps_priority_mail_flat_rate_package',
  },
  {
    label: 'Cubic',
    value: 'usps_cubic_soft_pack',
  },
  {
    label: 'FedEx One Rate Package',
    value: 'fedex_onerate',
  },
]

export const PARAMS_ORDER_FILTER = [
  'date_from',
  'date_to',
  'batch',
  'a1_batch',
  'ship_by_date_from',
  'ship_by_date_to',
  'customer',
  'order_ref',
  'service',
  'package_type',
  'preset_id',
  'assigned_id',
  'item_name',
  'item_sku',
  'tag_id',
  'region',
  'order_note',
  'carrier',
]

export const SORT_KEYS_ORDER_VALIDATE = [
  'from',
  'to',
  'parcels',
  'check_weight',
  'ship_by_date',
  'international_option',
  'custom_items',
  'reference1',
  'order_items',
  'signature_confirmation',
  'insurance_option',
]

export const OrderType = {
  SHIPBAE: 'shipbae',
  SHIPSTATION: 'shipstation',
  SHOPIFY: 'shopify',
  WALMART: 'walmart',
  TIKTOK: 'tiktok',
  EBAY: 'ebay',
  TEMU: 'temu',
  WOOCOMMERCE: 'woocommerce',
  MAGENTO: 'magento',
}

export const COLORS = [
  {name: 'RED_ORANGE', color: '#ef462d'},
  {name: 'PINK_RED', color: '#e42165'},
  {name: 'PURPLE', color: '#9920b7'},
  {name: 'DARK_PURPLE', color: '#6535be'},
  {name: 'BLUE_PURPLE', color: '#404ebc'},
  {name: 'GREEN', color: '#55b03e'},
  {name: 'TEAL', color: '#209688'},
  {name: 'LIGHT_BLUE', color: '#2abbd7'},
  {name: 'BRIGHT_BLUE', color: '#25a7fb'},
  {name: 'MEDIUM_BLUE', color: '#2f93fa'},
  {name: 'LIME_GREEN', color: '#8ec429'},
  {name: 'YELLOW_GREEN', color: '#cede00'},
  {name: 'BRIGHT_YELLOW', color: '#ffed00'},
  {name: 'GOLD', color: '#fdc300'},
  {name: 'ORANGE', color: '#fc9a00'},
  {name: 'BLACK', color: '#000000'},
  {name: 'GRAY_BLUE', color: '#617d8c'},
  {name: 'LIGHT_GRAY', color: '#9e9e9e'},
  {name: 'BROWN', color: '#785646'},
  {name: 'DARK_ORANGE', color: '#fa5a01'},
]

export const TUTORIAL_CARDS = [
  {
    key: 'payment',
    titleId: 'FUND_YOUR_WALLET',
    contentId: 'FUND_YOUR_WALLET_CONTENT',
    linkTo: ROUTES.DEPOSITS.BASE,
    canSkip: false,
  },
  {
    key: 'store',
    titleId: 'CONNECT_PARTY_STORE',
    contentId: 'CONNECT_PARTY_STORE_CONTENT',
    linkTo: ROUTES.SETTINGS.CONNECTIONS.BASE,
    canSkip: true,
  },
  {
    key: 'order',
    titleId: 'CREATE_FIRST_ORDER',
    titleId2: 'UPLOAD_FIRST_BATCH',
    contentId: 'CREATE_FIRST_ORDER_CONTENT',
    linkTo: ROUTES.ORDERS.CREATE,
    linkTo2: ROUTES.BATCHES.BASE,
    canSkip: false,
  },
  {
    key: 'shipment',
    titleId: 'PRINT_LABEL',
    contentId: 'PRINT_LABEL_CONTENT',
    linkTo: ROUTES.ORDERS.BASE,
    canSkip: false,
  },
  {
    key: 'notification',
    titleId: 'SETUP_NOTIFICATION',
    contentId: 'SETUP_NOTIFICATION_CONTENT',
    linkTo: ROUTES.SETTINGS.GENERAL,
    canSkip: true,
    subLinkText: 'LEARN_NOTIFICATION',
    subLinkTo: '/help-center/settings/notifications',
  },
]

export const ORDER_COLUMN_KEYS = {
  SHIPPED_DATE: 'shipped_date',
  HOLD_UNTIL_DATE: 'hold_until_date',
  CANCELLED_AT: 'cancelled_at',
  ITEM_NAME: 'item_name',
  ITEM_SKU: 'item_sku',
  ITEM_QUANTITY: 'item_quantity',
  CREATED_AT: 'created_at',
  CODE: 'code',
  SHIP_BY_DATE: 'ship_by_date',
  A1_BATCH: 'a1_batch',
  BATCH: 'batch',
  CUSTOMER: 'customer',
  STATUS: 'status',
  PACKAGE_INFO: 'package_info',
  TOTAL_WEIGHT: 'total_weight',
  RATES: 'rates',
  OUT_FOR_DELIVERY: 'out_for_delivery',
  TRACKING_NUMBER: 'tracking_number',
  CUSTOMER_TRACKING_NUMBER: 'customer_tracking_number',
  REFERENCER_1: 'reference1',
  ASSIGNED_NAME: 'assigned_name',
  TAG: 'tag',
  STORE_NAME: 'store_name',
  NOTE: 'note',
}

export const HIDDEN_COLUMNS_BY_DEFAULT = [
  ORDER_COLUMN_KEYS.SHIPPED_DATE,
  ORDER_COLUMN_KEYS.HOLD_UNTIL_DATE,
  ORDER_COLUMN_KEYS.CANCELLED_AT,
  ORDER_COLUMN_KEYS.SHIP_BY_DATE,
  ORDER_COLUMN_KEYS.ITEM_NAME,
  ORDER_COLUMN_KEYS.ITEM_SKU,
  ORDER_COLUMN_KEYS.ITEM_QUANTITY,
  ORDER_COLUMN_KEYS.NOTE,
]

export const HIDDEN_COLUMNS_BY_OPEN_AND_AWAITING_PAYMENT = [
  ORDER_COLUMN_KEYS.SHIPPED_DATE,
  ORDER_COLUMN_KEYS.HOLD_UNTIL_DATE,
  ORDER_COLUMN_KEYS.CANCELLED_AT,
  ORDER_COLUMN_KEYS.STATUS,
  ORDER_COLUMN_KEYS.ITEM_NAME,
  ORDER_COLUMN_KEYS.ITEM_SKU,
  ORDER_COLUMN_KEYS.ITEM_QUANTITY,
  ORDER_COLUMN_KEYS.NOTE,
]

export const HIDDEN_COLUMNS_BY_SHIPPED = [
  ORDER_COLUMN_KEYS.HOLD_UNTIL_DATE,
  ORDER_COLUMN_KEYS.CANCELLED_AT,
  ORDER_COLUMN_KEYS.SHIP_BY_DATE,
  ORDER_COLUMN_KEYS.STATUS,
  ORDER_COLUMN_KEYS.ITEM_NAME,
  ORDER_COLUMN_KEYS.ITEM_SKU,
  ORDER_COLUMN_KEYS.ITEM_QUANTITY,
  ORDER_COLUMN_KEYS.NOTE,
]

export const HIDDEN_COLUMNS_BY_ON_HOLD = [
  ORDER_COLUMN_KEYS.SHIPPED_DATE,
  ORDER_COLUMN_KEYS.CANCELLED_AT,
  ORDER_COLUMN_KEYS.SHIP_BY_DATE,
  ORDER_COLUMN_KEYS.STATUS,
  ORDER_COLUMN_KEYS.ITEM_NAME,
  ORDER_COLUMN_KEYS.ITEM_SKU,
  ORDER_COLUMN_KEYS.ITEM_QUANTITY,
  ORDER_COLUMN_KEYS.NOTE,
]

export const HIDDEN_COLUMNS_BY_CANCELLED = [
  ORDER_COLUMN_KEYS.SHIPPED_DATE,
  ORDER_COLUMN_KEYS.HOLD_UNTIL_DATE,
  ORDER_COLUMN_KEYS.SHIP_BY_DATE,
  ORDER_COLUMN_KEYS.STATUS,
  ORDER_COLUMN_KEYS.ITEM_NAME,
  ORDER_COLUMN_KEYS.ITEM_SKU,
  ORDER_COLUMN_KEYS.ITEM_QUANTITY,
  ORDER_COLUMN_KEYS.NOTE,
]

export const SYNC_STATUS = {
  IDLE: 'idle',
  SYNCING: 'syncing',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded',
  RETRYING: 'retrying',
  CANCELLED: 'cancelled',
}
